import { Component, OnInit } from '@angular/core';
import { AppState, BrandsActionTypes, MyNotificationsActionTypes, selectProfile } from '@app/core/ngrx';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { User } from '@app/core/models';
import { MyNotificationsService, NotificationService } from '@app/core/services';
import { take } from 'rxjs/operators';

/**
 * FrameReturnComponent
 */
@Component({
  selector: 'ecp-frame-return',
  templateUrl: './frame-return.component.html',
  styleUrls: ['./frame-return.component.scss'],
})
export class FrameReturnComponent implements OnInit {
  public user$: Observable<any>;
  public userProfile$: Observable<User>;
  public notifications$: Observable<any>;

  constructor(
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private myNotificationsService: MyNotificationsService,
  ) {
    // we need to get the VisionWeb token from the user's profile
    this.userProfile$ = this.store.pipe(select(selectProfile));
    this.userProfile$.subscribe(user => {
      if (user.token) {
        window.localStorage.setItem('token', user.token);
        this.store.dispatch({ type: BrandsActionTypes.LOAD_BRANDS, programKey: user.program.programKey });
        this.store.dispatch({
          type: MyNotificationsActionTypes.LOAD_MY_NOTIFICATIONS,
          programKey: user.program.programKey
        });
      }
    });
  }

  /**
   * ngOnInit
   */
  ngOnInit() {
    this.user$ = this.store.pipe(select(state => state.user));
    this.notifications$ = this.store.pipe(select(state => state.myNotifications));
    this.notifications$.pipe().subscribe((notifications: any) => {
      if (notifications && !notifications.acknowledge) {
        try {
          let notificationOptions = {
            title: 'Notification',
            contentHtml: notifications.list.htmlContent,
            confirmBtnText: 'Acknowledged',
            buttonClicked: () => {
              this.store.dispatch({
                type: MyNotificationsActionTypes.PATCH_MY_NOTIFICATIONS,
              });
            },
          };
          this.notificationService.error(notificationOptions);
          this.myNotificationsService.notifiedFlag = true;
        } catch (e) {
          //do nothing
        }
      }
    });
  }
}
